/**
 * Grieg API - Rendered View (READ ONLY)
 * Service to manage the core configuration details for individual tenants.   ### Design notes Note that in contrast to other services, tenants will be identified by a short code (that can be consistent between environments). This code can be specified as part of the creation and will be ensured is unique.
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type PolicyOutcome = 'GRANT' | 'DENY' | 'POLICY_DOCUMENT_NOT_FOUND' | 'POLICY_DOCUMENT_ERROR';

export const PolicyOutcome = {
  GRANT: 'GRANT' as PolicyOutcome,
  DENY: 'DENY' as PolicyOutcome,
  POLICYDOCUMENTNOTFOUND: 'POLICY_DOCUMENT_NOT_FOUND' as PolicyOutcome,
  POLICYDOCUMENTERROR: 'POLICY_DOCUMENT_ERROR' as PolicyOutcome,
};
